import axiosClient from './axiosService';

export const getAllComments = () => {
    return axiosClient.get('/comments');
};

export const createComment = (comment) => {
    return axiosClient.post('/comments', comment);
};

export const getCommentsByCoordinatorEmail = (coordinatorEmail) => {
    return axiosClient.get('/comments/by-coordinator-email', {
        params: { coordinatorEmail }
    });
};

export const getCommentsByProgressId = (progressId) => {
    return axiosClient.get('/comments/by-progress-id', {
        params: { progressId }
    });
};

export const getCommentsByCommentedDate = (commentedDate) => {
    return axiosClient.get('/comments/by-commented-date', {
        params: { commentedDate }
    });
};

export const getTotalCommentCount = () => {
    return axiosClient.get('/comments/count');
};